import { render, staticRenderFns } from "./LSelect.vue?vue&type=template&id=bc44bea8"
import script from "./LSelect.vue?vue&type=script&lang=js"
export * from "./LSelect.vue?vue&type=script&lang=js"
import style0 from "./LSelect.vue?vue&type=style&index=0&id=bc44bea8&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports